import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

const GRADIENTS = ['#3ecf8e,#14b8a6', '#f59e0b,#ef4444', '#8b5cf6,#ec4899', '#06b6d4,#3b82f6', '#10b981,#059669'];

export const ImageCardGrid: React.FC<Props> = ({ config, links }) => {
  // Use correct field names from types.ts
  const {
    moduleHeading = 'Related Products',
    headingTag = 'h2',
    gridColumns = '3',
    cardStyle = 'elevated',
    maxCards = 8,
    showTitle = true,
    showDescription = false,
  } = config;

  const HeadingTag = headingTag as keyof JSX.IntrinsicElements;
  const cols = gridColumns === 'auto-fit' ? 3 : parseInt(gridColumns, 10) || 3;
  const displayLinks = links.slice(0, maxCards);

  // Get card style
  const getCardStyle = (): React.CSSProperties => {
    switch (cardStyle) {
      case 'flat':
        return { background: 'white' };
      case 'bordered':
        return { background: 'white', border: '1px solid #e5e7eb' };
      default: // elevated
        return { background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' };
    }
  };

  return (
    <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <HeadingTag
        style={{ color: '#1e3a5f', marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600, margin: '0 0 1rem 0' }}
      >
        {moduleHeading}
      </HeadingTag>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: '1rem' }}>
        {displayLinks.map((link, i) => {
          const gradient = GRADIENTS[i % GRADIENTS.length];
          return (
            <a
              key={i}
              href={link.url}
              style={{
                ...getCardStyle(),
                borderRadius: '8px',
                overflow: 'hidden',
                textDecoration: 'none',
                display: 'block',
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
            >
              <div
                style={{
                  height: '160px',
                  background: link.image ? `url(${link.image}) center/cover` : `linear-gradient(135deg, ${gradient})`,
                  overflow: 'hidden',
                }}
              >
                {link.image && (
                  <img
                    src={link.image}
                    alt={link.title || ''}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                )}
              </div>
              {showTitle && (
                <div style={{ padding: '0.75rem' }}>
                  <span style={{ display: 'block', color: '#1e3a5f', fontWeight: 500, fontSize: '0.95rem' }}>
                    {link.title || link.anchorText || link.url}
                  </span>
                  {showDescription && link.description && (
                    <p style={{ color: '#64748b', fontSize: '0.85rem', marginTop: '0.25rem', margin: '0.25rem 0 0' }}>
                      {link.description}
                    </p>
                  )}
                </div>
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
};
